import React from 'react';

// Importing focal background asset to contextualize corporate values
import corporatePillarBg from '../assets/banner4.jpg';

const HomeBanner3 = () => {
  const values = [
    { no: '01', title: 'Integrity', desc: 'We conduct our business honestly, ethically, and transparently in all our dealings.' },
    { no: '02', title: 'Quality Excellence', desc: 'We are committed to delivering products and services that consistently meet and exceed customer expectations.' },
    { no: '03', title: 'Sustainability', desc: 'We embrace environmentally responsible practices that protect resources for future generations.' },
    { no: '04', title: 'Innovation', desc: 'We continuously seek better ways to solve challenges and create value.' },
    { no: '05', title: 'Community Impact', desc: 'We believe business success should contribute to the well-being and prosperity of the communities we serve.' },
    { no: '06', title: 'Reliability', desc: 'We honor our commitments and build lasting relationships through trust and dependable service.' },
  ];

  return (
    <section style={styles.valuesSection} className="py-5">
      <div className="container my-lg-4">
        <div className="row g-5 align-items-start">
          
          {/* Static Info & Masked Graphic Panel Column */}
          <div className="col-12 col-lg-5 position-md-sticky" style={{ top: '100px' }}>
            <div className="mb-4">
              <div style={styles.sectionLabel} className="text-uppercase mb-2">Corporate Pillars</div>
              <h2 style={styles.sectionTitle} className="fw-medium text-white mb-3">Our Core Values</h2>
              <p style={styles.sectionDesc} className="mb-4">
                Driven by foundational ethics, Tanzavibe Holdings seeks to become a trusted partner 
                in transforming natural resources into lasting prosperity for communities across Tanzania and beyond.
              </p>
            </div>
            
            {/* Visual Fusion Block - Minimalist Glassmorphic Overlay Window */}
            <div 
              style={{ ...styles.visualFusionBox, backgroundImage: `url(${corporatePillarBg})` }}
              className="w-100 d-flex align-items-end p-4 position-relative overflow-hidden"
            >
              <div style={styles.imageDarkener}></div>
              <div style={styles.glassmorphicTag} className="position-relative p-3 w-100 text-center">
                <span style={styles.tagText} className="text-uppercase fw-semibold tracking-wider">
                  National Stewardship Registered
                </span>
              </div>
            </div>
          </div>

          {/* List Flow Panel Column */}
          <div className="col-12 col-lg-7">
            <div className="d-flex flex-column">
              <ul style={styles.valueUl} className="m-0 p-0">
                {values.map((item, index) => (
                  <li key={index} style={styles.valueLi} className="d-flex align-items-start gap-3 py-4">
                    <span style={styles.number} className="fw-semibold">{item.no}</span>
                    <div className="d-flex flex-column">
                      <h4 style={styles.valueTitle} className="text-white mb-2 fw-medium">{item.title}</h4>
                      <p style={styles.valueDesc} className="m-0">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const styles = {
  valuesSection: {
    backgroundColor: '#0A0F18',
    fontFamily: "'Libre Franklin', sans-serif",
  },
  sectionLabel: {
    fontSize: '11px',
    color: '#38A169',
    letterSpacing: '0.15em',
  },
  sectionTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'calc(1.8rem + 1vw)',
  },
  sectionDesc: {
    fontSize: '15px',
    color: '#A0AEC0',
    lineHeight: '1.75',
  },
  visualFusionBox: {
    height: '240px',
    borderRadius: '6px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid #1E2D4A',
  },
  imageDarkener: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(10, 15, 24, 0.4)',
    zIndex: 1,
  },
  glassmorphicTag: {
    zIndex: 2,
    backgroundColor: 'rgba(17, 26, 46, 0.75)',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(30, 45, 74, 0.8)',
    borderRadius: '4px',
  },
  tagText: {
    fontSize: '11px',
    color: '#ED8936',
    letterSpacing: '0.1em',
  },
  valueUl: {
    listStyle: 'none',
  },
  valueLi: {
    borderBottom: '1px solid rgba(30, 45, 74, 0.6)',
  },
  number: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '22px',
    color: '#ED8936',
    lineHeight: '1',
    minWidth: '28px',
  },
  valueTitle: {
    fontSize: '17px',
    letterSpacing: '0.02em',
  },
  valueDesc: {
    fontSize: '14.5px',
    color: '#CBD5E0',
    lineHeight: '1.65',
  },
};

export default HomeBanner3;